import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function Testimonials() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Testimonial</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Testimonial</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody testimonial-section">
                <div className="container them-container">
                    <div className="row testimonial-list">
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “Walking my son into the same classrooms where I once studied fills me with pride. St. Mary’s Nursery School isn’t just a school for us—it’s family. The teachers are warm, patient, and truly understand every child’s emotional and learning needs. The NEP-based approach and smart classrooms make learning so joyful. I couldn’t think of a better place to begin my child’s journey.”
                                </p>
                                <h5 className="testimonial-author">Mrs. Neha Sharma</h5>
                                <span className="testimonial-role">Parent & Former Student</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “We are the third generation in our family to trust St. Mary’s! My mother studied here, I studied here, and now my daughter is continuing the legacy. The school beautifully blends modern education with strong moral values. Bagless Fridays and activity-based learning have made my child love school every single day!”
                                </p>
                                <h5 className="testimonial-author">Mr. Rohit & Mrs. Anjali Mehta</h5>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “My grandchildren are now learning under the same care and values that my children once received here decades ago. SMNS continues to uphold its reputation for safety, compassion, and quality education. The teachers’ dedication and the principal’s personal attention to every child are truly commendable.”
                                </p>
                                <h5 className="testimonial-author">Mrs. Reshma Roy</h5>
                                <span className="testimonial-role">Grandparent</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “We were amazed to see how smoothly our little one settled in. The school ensures emotional comfort and fun-filled learning from day one. From the RO water plant to clean surroundings and constant power backup—every detail reflects how much the school cares. We’re so grateful for the loving start our son has got.”
                                </p>
                                <h5 className="testimonial-author">Mr. Md. Ansari & Mrs. Shabnam Ansari</h5>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “SMNS shaped my own childhood, and now it’s shaping my daughter’s. The play-way method and NEP-based curriculum make learning creative and stress-free. The teachers are like second parents, always encouraging curiosity and kindness. We feel blessed to be part of this legacy once again!”
                                </p>
                                <h5 className="testimonial-author">Mrs. Deepa Joseph </h5>
                                <span className="testimonial-role">Former Student & Current Parent</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “St. Mary’s Nursery School has redefined early education in Bokaro. The interactive smart panels, safe premises, and caring staff make it a second home for our kids. We love how the school teaches not only academics but values like sharing, empathy, and responsibility.”
                                </p>
                                <h5 className="testimonial-author">Mr. & Mrs. Ashok Pandey</h5>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “I taught at SMNS in the 1980s, my daughter studied here in the 1990s, and now my grandson goes here. That’s three generations of trust and for good reason! The school’s focus on overall development, discipline, and character-building remains unmatched. It’s heartwarming to see how the school has evolved yet stayed true to its roots.”
                                </p>
                                <h5 className="testimonial-author">Mrs. Subhlakshmi Raut</h5>
                                <span className="testimonial-role">Grandparent & Former Teacher</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “Every morning, my daughter runs to school with excitement. That says everything! The creative classroom themes, regular parent communication, and joyful learning activities are incredible. We appreciate the principal and staff for maintaining such high standards with love and personal attention.”
                                </p>
                                <h5 className="testimonial-author">Mr. Salim Khan</h5>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “From the same corridors where I once sang morning prayers, my little one now learns rhymes! St. Mary’s Nursery School has preserved the same warmth, discipline, and care that I remember. The new-age facilities like smart boards and the bagless concept make it even better today.”
                                </p>
                                <h5 className="testimonial-author">Mrs. Shweta George</h5>
                                <span className="testimonial-role">Parent & Alumnus</span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 testimonial-card">
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “We enrolled our son after hearing so many good things—and every word was true! The school creates an environment where children learn through love and exploration. The staff’s patience, the fun-filled Friday activities, and the personal connection they maintain with parents make SMNS truly special.”
                                </p>
                                <h5 className="testimonial-author">Mr. and Mrs. Vivek Jha</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Testimonials